import { InvoiceModalComponent } from './invoice-modal/invoice-modal.component';
// tslint:disable-next-line:import-spacing
import { CommonModule, DatePipe } from  '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// tslint:disable-next-line:max-line-length
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { ProductModalComponent } from './product-modal/product-modal.component';
import { PurchaseorderModalComponent } from './purchaseorder-modal/purchaseorder-modal.component';
import { PurchaseorderDeleteModalComponent } from './purchaseorder-delete-modal/purchaseorder-delete-modal.component';
import { RegionsModalComponent } from './regions-modal/regions-modal.component';
import { CountriesModalComponent } from './countries-modal/countries-modal.component';
import { AntennasModalComponent } from './antennas-modal/antennas-modal.component';
import { ProductCategoriesModalComponent } from './product-categories-modal/product-categories-modal.component';
import { LocationsModalComponent } from './locations-modal/locations-modal.component';
import { WarehousesModalComponent } from './warehouses-modal/warehouses-modal.component';
import { StoresModalComponent } from './stores-modal/stores-modal.component';
import { DashboardModalComponent } from './dashboard-modal/dashboard-modal.component';
import { BodypartsModalComponent } from './bodyparts-modal/bodyparts-modal.component';
import { ImplantsModalComponent } from './implants-modal/implants-modal.component';
import { DashboardTrackingModalComponent } from './dashboard-tracking-modal/dashboard-tracking-modal.component';
import { TrackingModalComponent } from './tracking-modal/tracking-modal.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { ProductsListModalComponent } from './products-list-modal/products-list-modal.component';
import { ProductViewModalComponent } from './product-view-modal/product-view-modal.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { UserRolesModalComponent } from './user-roles-modal/user-roles-modal.component';
import { UserModalComponent } from './user-modal/user-modal.component';
import { ReportModalComponent } from './report-modal/report-modal.component';
import { LogoComponent } from './logo/logo.component';



@NgModule({
  declarations: [
    InvoiceModalComponent,
    ProductModalComponent,
    RegionsModalComponent,
    CountriesModalComponent,
    AntennasModalComponent,
    ProductCategoriesModalComponent,
    LocationsModalComponent,
    WarehousesModalComponent,
    StoresModalComponent,
    DashboardModalComponent,
    PurchaseorderModalComponent,
    PurchaseorderDeleteModalComponent,
    ProductsListModalComponent,
    BodypartsModalComponent,
    // ImplantsModalComponent,
    DashboardTrackingModalComponent,
    TrackingModalComponent,
    DeleteModalComponent,
    ProductViewModalComponent,
    ConfirmationModalComponent,
    UserRolesModalComponent,
    UserModalComponent,
    ReportModalComponent,
    InvoiceModalComponent,
    ProductModalComponent,
    RegionsModalComponent,
    AntennasModalComponent,
    CountriesModalComponent,
    ProductCategoriesModalComponent,
    LocationsModalComponent,
    WarehousesModalComponent,
    StoresModalComponent,
    DashboardModalComponent,
    PurchaseorderModalComponent,
    PurchaseorderDeleteModalComponent,
    BodypartsModalComponent,
    // ImplantsModalComponent,
    DashboardTrackingModalComponent,
    TrackingModalComponent,
    DeleteModalComponent,
    ProductViewModalComponent,
    ConfirmationModalComponent,
    UserRolesModalComponent,
    UserModalComponent,
    ReportModalComponent,
    LogoComponent
  ],

  imports: [
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    MatTabsModule 
  ],

  providers: [ ],
  exports: [LogoComponent],
})

export class SharedModule { }
